import React from 'react'
import {useNavigate } from 'react-router-dom'

export default function ClubUpdatedModal({id}) {
    const navi = useNavigate()
    //styled
    return (
        <div className="send-modal-overlay">
      
        <div className="send-modal">
        <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Club Updated</p></div> 
        <p>The club information has been updated successfully.</p>

            <div className="send-modal-footer">
              <button className="saveChanges-button mx-3" onClick={() => navi(`/myoneclub/${id}`)}>
              Okay
               
                </button>
        
            </div>
        
        </div>
      </div>
      )
    }
    